// src/utils/slugify.js

// Título bonito
export function toTitleCase(s = "") {
  return String(s)
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim()
    .replace(/(^|\s)\S/g, (m) => m.toUpperCase());
}

// Slug ROBUSTO (para IDs/keys: MAYÚSCULAS + _)
export function slugify(s = "") {
  return String(s)
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/_{2,}/g, "_")
    .replace(/^_|_$/g, "");
}

// Alias estable para quien lo importe como keySlug
export const keySlug = slugify;

// Nombre de carpeta visible (bonito) a partir de nombre + apellidos
export function folderNameFromFullName(nombre = "", apellidos = "") {
  const full = `${nombre || ""} ${apellidos || ""}`.replace(/\s+/g, " ").trim();
  return full ? toTitleCase(full) : "Conductor";
}

// Variante que también acepta DNI como fallback
export function folderNameFromNameOrDni(nombre = "", apellidos = "", dni = "") {
  const full = `${nombre || ""} ${apellidos || ""}`.replace(/\s+/g, " ").trim();
  if (full) return toTitleCase(full);
  if (dni) return dni.toString().trim();
  return "Conductor";
}
